
import { applyOpacityToHex } from './defaultColors';

//  Greyscale palette
const black= '#343434';
const shadowGrey= '#51514f';
const slateGrey= '#84827f';
const koalaGrey= '#a2a09e';
const cloudyGrey= '#c0bebc';
const silverGrey= '#ecebea';
const shinyGrey= '#fcfcfb';
const white= '#FFFFFF';

const greyScale = [
  white,
  shinyGrey,
  silverGrey,
  cloudyGrey,
  koalaGrey,
  slateGrey,
  shadowGrey,
  black,
];

const colors = {
  primary: {
    light: '#9a9a9a',
    main: '#1582e6',
    dark: '#40a3ff',
  },
  secondary: {
    light: '#004eae',
    main: '#2989ff',
    dark: '#afdaff',
  },
  error: {
    main: '#ca564e',
  },
  text: {
    primary: '#ffffff',
    secondary: '#c8c8c8',
    disabled: '#aaaaaa',
    lightContrast: '#ffffff',
  },
  action: {
    active: applyOpacityToHex(greyScale[0], 0.5),
  },
  other: {
    quickTips: 'rgb(255,183,125)',
    dueTxn: '#f29d50',
    acmeMain: '#4b86c0',
  },
  money: {
    positiveBright: '#05e343',
    positive1: '#116611',
    positive2: '#03a710',
    negativeBright: '#ffe214',
    negative1: '#d70015',
    negative2: '#f5a623',
  },
};



export const THEME = {
  typography: {
    useNextVariants: true,
    caption: {
      color: greyScale[2],
    },
    h3: {
      color: applyOpacityToHex(greyScale[0], 0.93),
    },
    h4: {
      color: applyOpacityToHex(greyScale[0], 0.93),
    },
    h5: {
      color: applyOpacityToHex(greyScale[0], 0.91),
    },
    h6: {
      color: applyOpacityToHex(greyScale[0], 0.89),
    },
    body1: {
      color: applyOpacityToHex(greyScale[0], 0.87),
    },
    body2: {
      color: applyOpacityToHex(greyScale[0], 0.87),
    },
  },
  palette: {
    ...colors,
    greyScale,
    //  TEMPORARY?
    background: {
      default: '#1a1a1a',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    //  TEMPORARY
    qCards: {
      backgroundColor: '#085c8c',
      titleColor: '#cccccc',
      contentColor: '#989898',
      closeColor: '#303030',
      highlightColor: '#ca059f',
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: greyScale[7],
      },
    },
    MuiIconButton: {
      // color: applyOpacityToHex(greyScale[1], 0.93),
    },
  },
  // override specific component styles for ACME theme, colors should be referenced from the 'colors' object above,
  //    ----- ONLY in special cases should there be hex codes below here -----
  components: {
    register: {
      // -- COLORS -- //
      fieldBorderColor: '#4a90e2',
      headerBackground: greyScale[6],
      headerBorder: applyOpacityToHex(greyScale[5], 0.5),
      editRowColor: greyScale[6],
      sectionHeaderColor: applyOpacityToHex(greyScale[5], 0.3),
      rowHoverColor: greyScale[6],
      fieldHoverColor: applyOpacityToHex(greyScale[7], 0.2),
    },
    amountField: {
      positiveColor: colors.money.positiveBright,
      negativeColor: '#d70015',
      negativeColor2: '#f5a623',
      positiveColor2: colors.money.positive2,
    },
    projectedBalances: {
      standardColor: '#0a91ff',
      positiveGradientDark: '#00bcce',
      positiveGradientLight: 'rgba(0, 49, 117, 0)',
      negativeGradientDark: 'rgba(214, 9, 2, 0.8)',
      negativeGradientLight: 'rgba(252, 223, 116, 0)',
    },
    categoryRegister: {
      labelHover: 'rgba(255, 255, 255, 0.2)',
      icon: 'rgba(255, 255, 255, 0.5)',
      collapseFilter: 'invert(1)',
    },
  },
};

// this is a unique key for identifying this mask
export const THEME_KEY = 'ACME_DARK';
